import React from "react";
import { Modal, Box, Grid } from "@mui/material";

const ActionModal = ({
  open,
  modalContent,
  modalTitle,
  transparent,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    height: "auto",
    border: false,
    boxShadow: 24,
    borderRadius: "0.5em",
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      slotProps={{
        backdrop: { style: { backgroundColor: "rgba(0, 0, 0, 0.6)" } },
      }}
    >
      <Box sx={style} className="ModalBG">
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          lg={12}
          xs={12}
          md={12}
          className="GradiantButton rounded-top "
        >
          <Grid
            container
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            className="p-3  rounded-top"
          >
            {modalTitle}
          </Grid>
        </Grid>
        <Grid className={transparent ? "" : "p-3"}>{modalContent}</Grid>
      </Box>
    </Modal>
  );
};

export default ActionModal;
